import { render, staticRenderFns } from "./organizationalInfo.vue?vue&type=template&id=fc6bf40e&scoped=true"
import script from "./organizationalInfo.vue?vue&type=script&lang=js"
export * from "./organizationalInfo.vue?vue&type=script&lang=js"
import style0 from "./organizationalInfo.vue?vue&type=style&index=0&id=fc6bf40e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc6bf40e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc6bf40e')) {
      api.createRecord('fc6bf40e', component.options)
    } else {
      api.reload('fc6bf40e', component.options)
    }
    module.hot.accept("./organizationalInfo.vue?vue&type=template&id=fc6bf40e&scoped=true", function () {
      api.rerender('fc6bf40e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/organizationalManage/organizationalInfo.vue"
export default component.exports